import React, { PureComponent } from 'react';

interface IProps {
  src: string;
}

export default class LoopedAudio extends PureComponent<IProps> {
  private audio: HTMLAudioElement | null = null;

  public render() {
    return <audio src={this.props.src} preload="auto" loop autoPlay ref={this.setRef} />;
  }

  private setRef = (audio: HTMLAudioElement | null) => {
    // Disable autoplay in Safari before unmounting because it has
    // a bug that will start playing all autoplay audio elements
    // even after the element is gone; once microphone access has
    // been acquired via getUserMedia
    if (!audio && this.audio) {
      this.audio.autoplay = false;
    }

    this.audio = audio;
  };
}
